module.exports = __webpack_public_path__ + "img/79.0c7a8206.png";